<script>
export default {
	props: {
		data: Object,
	},
	computed: {
		groupedProducts() {
			const groupedProducts = []
			const groupSize = this.$b.m ? 2 : 3
			for (let i = 0; i < this.data.products.length; i += groupSize) {
				groupedProducts.push(this.data.products.slice(i, i + groupSize))
			}
			return groupedProducts
		},
		imageProps() {
			return this.$b.props({
				height: { td: '702px' },
				width: { td: '530px', m: '100%' },
			})
		},
	},
}
</script>

<template>
	<Container class="ecomodico-products-board pa-0" :class="{ 'd-flex --desktop': !$b.m }">
		<div
			:class="{ 'flex-row-reverse': !data.invertImage && !$b.m, 'flex-column': $b.m }"
			class="d-flex"
			style="gap: 24px"
		>
			<div>
				<SafeLink :to="data.imgUrl">
					<Media
						class="__banner"
						:class="{ 'mb-2': $b.m }"
						:src="$b.m ? data.imgMobile : data.img"
						v-bind="imageProps"
					/>
				</SafeLink>
			</div>
			<ProductsCarousel
				v-if="$b.m"
				:products="data.products"
				slides-per-page="2"
				gutter="12"
				arrows-bg-half-rounded
				:list-id="`ecomodico-products-board`"
			/>
			<div v-else class="d-flex flex-column justify-center px-2 px-sm-0" style="gap: 12px">
				<div
					v-for="(group, i) in groupedProducts"
					:key="i"
					class="d-flex align-start justify-center"
					:style="{ gap: $b.m ? '12px' : '24px' }"
				>
					<div
						v-for="(product, j) in group"
						:key="j"
						:style="$b.m ? 'width: 50%' : 'width: 33%'"
						class="flex-grow-0 h100"
					>
						<ProductCard class="h100" :product="product" :listIndex="j" />
					</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<style scoped lang="scss">
.ecomodico-products-board {
	::v-deep .product-card-design1-vertical-wrapper {
		width: unset !important;
		min-height: unset !important;
	}

	&.--desktop .__banner ::v-deep img {
		border-radius: 16px;
	}
}
</style>

